module.exports = __webpack_public_path__ + "static/media/branches.5947f390.svg";